/**
 * 模版瀑布流容器
 * @author VenDream
 * @since 17/11/9
 */

import { connect } from 'react-redux';
import TplWaterfall from 'components/tpl-waterfall/tpl-waterfall';

const mapStateToProps = (state, ownProps) => {
  const tpls = [];

  for (const id of ownProps.tplids) {
    const tpl = state.tpls.byId[id];
    tpl && tpls.push(tpl);
  }

  return { tpls, ...ownProps };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TplWaterfall);
